import { AG_GRID_LOCALE_EN } from './en';
var locales = {
    en: AG_GRID_LOCALE_EN,
};
// TODO: How a user will change the language?
// TODO: Remove this function and use locale from ag-grid if possible. If not, use props.
export function t(key, lang) {
    if (lang === void 0) { lang = 'en'; }
    if (!key) {
        return '';
    }
    return locales[lang][key];
}
//# sourceMappingURL=getTranslation.js.map